import "./no-data-found.styles.css";

const NoDataFound = ({ text = "No Data Found" }) => {
  return (
    <div
      className={`timelist bg-primary no-data-container ${
        text.toLocaleLowerCase() === "no data found" ? "no-data-max-height" : ""
      }`}
    >
      <h4
        className={`text-center text-warning no-data-text ${
          text.toLocaleLowerCase() === "no data found" ? "sticky-text-vertical" : ""
        }`}
      >
        <span
          className={text.toLocaleLowerCase() === "no data found" ? "" : ""}
        >
          {text}
        </span>
      </h4>
    </div>
  );
};

export default NoDataFound;
